import { createBrowserRouter } from 'react-router-dom';
import App, { Home } from './App';
import Donate from './components/Donate';
import StoryPage from './pages/StoryPage';
import VolunteerPage from './pages/VolunteerPage';
import RegisterPage from './pages/RegisterPage';
import LoginPage from './pages/LoginPage';
import Volunteers from './pages/admin/Volunteers';
import Pledges from './pages/admin/Pledges';
import UsersAdminPage from './pages/admin/UsersAdminPage';
import Settings from './pages/admin/Settings';
import ContactPage from './pages/ContactPage';
import ErrorBoundary from './components/ErrorBoundary';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: 'donate',
        element: <Donate />,
      },
      {
        path: 'story',
        element: <StoryPage />,
      },
      {
        path: 'volunteer',
        element: <VolunteerPage />,
      },
    ],
  },
  {
    path: '/register',
    element: <RegisterPage />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/login',
    element: <LoginPage />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/admin/volunteers',
    element: <Volunteers />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/admin/pledges',
    element: <Pledges />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/admin/users',
    element: <UsersAdminPage />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/admin/settings',
    element: <Settings />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: '*',
    element: <ErrorBoundary />,
  },
]);

export default router;